import { render } from "./theme16.vue?vue&type=template&id=61b92f4c&scoped=true"
import script from "./theme16.vue?vue&type=script&lang=js"
export * from "./theme16.vue?vue&type=script&lang=js"

import "./theme16.vue?vue&type=style&index=0&id=61b92f4c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-61b92f4c"

export default script